mutation AddCampaignSection($clientId: ID!, $name: String!) {
    addCampaignSection(clientId: $clientId, name: $name) {
        _id
    }
}
